// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__zuLTe","link":"NavbarLinksGroup_link__KkruT","chevron":"NavbarLinksGroup_chevron__guQfz","nav_active":"NavbarLinksGroup_nav_active__9SNPM"};